import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ScriptName } from '../../shared/enum/script-name.enum';
interface Scripts {
  name: string;
  src: string;
}
export const scriptStore: Scripts[] = [
  { name: ScriptName.LOTTIE_SCRIPT, src: 'assets/js/lottie_light_min.min.js' }
];
@Injectable({
  providedIn: 'root'
})
export class ScriptLoaderService {
  private scripts: any = {};
  constructor(@Inject(DOCUMENT) private document: Document) {
    scriptStore.forEach((script: any) => {
      this.scripts[script.name] = {
        loaded: false,
        src: script.src
      };
    });
  }

  loadScript(name: string) {
    return new Observable((observer) => {
      if (this.scripts[name].loaded) {
        observer.next({ script: name, loaded: true, status: 'Already Loaded' });
        observer.complete();
      } else {
        const script = this.document.createElement('script');
        script.type = 'text/javascript';
        script.src = this.scripts[name].src;
        script.onload = () => {
          this.scripts[name].loaded = true;
          console.log(`${name} Loaded.`);
          observer.next({ script: name, loaded: true, status: 'Loaded' });
          observer.complete();
        };
        script.onerror = (error: any) => {
          observer.next({ script: name, loaded: false, status: 'Loaded' });
          observer.complete();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
      }
    });
  }
}
